// src/pages/restaurant-tables/LoungeCategories.jsx
import React from 'react';
import CategoryList from '../CategoryList';

const LoungeCategories = () => {
  return <CategoryList locationKey="lounge" />;
};

export default LoungeCategories;